import { environment } from '../../environments/environment';

export class Constants {
  /* public static URL_BACKEND = 'http://localhost:8951'; */
  public static URL_BACKEND = environment.BACKEND_URL;  // 'http://tbwabe.misolucioneswow.com';
  // public static URL_BACKEND = 'http://tracking.holinsys.net';
}



// WEBPACK FOOTER //
// ./src/app/shared/Constants.ts